
import { defineAsyncComponent, defineComponent, ref } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import Assets from "@/helpers/pages/Assets";
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";

export default defineComponent({
  name: "Assets",
  setup() {
    const module = ref(Assets);
    const breadcrumbComponent = defineAsyncComponent(
      () => import("@/views/pages/Assets/AssetBreadcrumb.vue")
    );
    const store = useStore();
    const setFilterStatus = () => {
      store.dispatch(GeneralActionTypes.FILTER_STATUS, false);
    };
    let filter = ref({
      page: 1,
      limit: 10,
      sortColumn: "",
      sortDir: "",
    });

    const RESETFILTER = filter;
    const getList = async (
      filters = filter.value,
      options = module.value.component.options
    ) => {
      const body = { filters, options };
      await store.dispatch(GeneralActionTypes.GET_ASSETS, body);
      options.allRows = options.rows;
    };

    const searchWithFilters = (param: any) => {
      filter.value.page = module.value.component.options.page || 0;
      filter.value.limit = module.value.component.options.pageSize || 5;
      filter.value.sortColumn = "";
      filter.value.sortDir = "";

      const filters = filter.value;
      const options = module.value.component.options;
      getList(filters, options);
    };

    const resetFilters = () => {
      searchWithFilters(true);
    };

    return {
      setFilterStatus,
      searchWithFilters,
      resetFilters,
      filter,
      getList,
      module,
      breadcrumbComponent,
    };
  },
  mounted() {
    this.setFilterStatus();
    const filters = this.filter;
    const options = this.module.component.options;
    this.getList(filters, options);
  },
  components: { AgCard },
});
